export default {
  TW: 'Taiwan',
  US: 'United States',
  AG: 'Antigua and Barbuda',
  AI: 'Anguilla',
  AS: 'American Samoa',
  BB: 'Barbados',
  BM: 'Bermuda',
  BS: 'Bahamas',
  CA: 'Canada',
  DM: 'Dominica',
  DO: 'Dominican Republic',
  GD: 'Grenada',
  GU: 'Guam',
  JM: 'Jamaica',
  KN: 'Saint Kitts and Nevis',
  KY: 'Cayman Islands',
  LC: 'Saint Lucia',
  MP: 'Northern Mariana Islands',
  MS: 'Montserrat',
  PR: 'Puerto Rico',
  SX: 'Sint Maarten (Dutch part)',
  TC: 'Turks and Caicos Islands',
  TT: 'Trinidad and Tobago',
  VC: 'Saint Vincent and the Grenadines',
  VG: 'British Virgin Islands',
  VI: 'U.S. Virgin Islands',
  RU: 'Russia',
  KZ: 'Kazakhstan',
  EG: 'Egypt',
  ZA: 'South Africa',
  GR: 'Greece',
  NL: 'Netherlands',
  BE: 'Belgium',
  FR: 'France',
  ES: 'Spain',
  HU: 'Hungary',
  IT: 'Italy',
  VA: 'Vatican',
  RO: 'Romania',
  CH: 'Switzerland',
  AT: 'Austria',
  GB: 'United Kingdom',
  GG: 'Guernsey',
  IM: 'Isle of Man',
  JE: 'Jersey',
  DK: 'Denmark',
  SE: 'Sweden',
  NO: 'Norway',
  SJ: 'Svalbard and Jan Mayen',
  PL: 'Poland',
  DE: 'Germany',
  PE: 'Peru',
  MX: 'Mexico',
  CU: 'Cuba',
  AR: 'Argentina',
  BR: 'Brazil',
  CL: 'Chile',
  CO: 'Colombia',
  VE: 'Venezuela',
  MY: 'Malaysia',
  AU: 'Australia',
  CC: 'Cocos (Keeling) Islands',
  CX: 'Christmas Island',
  ID: 'Indonesia',
  PH: 'Philippines',
  NZ: 'New Zealand',
  SG: 'Singapore',
  TH: 'Thailand',
  JP: 'Japan',
  KR: 'South Korea',
  VN: 'Vietnam',
  CN: 'China',
  TR: 'Turkey',
  IN: 'India',
  PK: 'Pakistan',
  AF: 'Afghanistan',
  LK: 'Sri Lanka',
  MM: 'Myanmar',
  IR: 'Iran',
  SS: 'South Sudan',
  MA: 'Morocco',
  EH: 'Western Sahara',
  DZ: 'Algeria',
  TN: 'Tunisia',
  LY: 'Libya',
  GM: 'Gambia',
  SN: 'Senegal',
  MR: 'Mauritania',
  ML: 'Mali',
  GN: 'Guinea',
  CI: 'Ivory Coast',
  BF: 'Burkina Faso',
  NE: 'Niger',
  TG: 'Togo',
  BJ: 'Benin',
  MU: 'Mauritius',
  LR: 'Liberia',
  SL: 'Sierra Leone',
  GH: 'Ghana',
  NG: 'Nigeria',
  TD: 'Chad',
  CF: 'Central African Republic',
  CM: 'Cameroon',
  CV: 'Cape Verde',
  ST: 'São Tomé and Príncipe',
  GQ: 'Equatorial Guinea',
  GA: 'Gabon',
  CG: 'Republic of the Congo',
  CD: 'Democratic Republic of the Congo',
  AO: 'Angola',
  GW: 'Guinea-Bissau',
  IO: 'British Indian Ocean Territory',
  AC: 'Ascension Island',
  SC: 'Seychelles',
  SD: 'Sudan',
  RW: 'Rwanda',
  ET: 'Ethiopia',
  SO: 'Somalia',
  DJ: 'Djibouti',
  KE: 'Kenya',
  TZ: 'Tanzania',
  UG: 'Uganda',
  BI: 'Burundi',
  MZ: 'Mozambique',
  ZM: 'Zambia',
  MG: 'Madagascar',
  RE: 'Réunion',
  YT: 'Mayotte',
  ZW: 'Zimbabwe',
  NA: 'Namibia',
  MW: 'Malawi',
  LS: 'Lesotho',
  BW: 'Botswana',
  SZ: 'Swaziland',
  KM: 'Comoros',
  SH: 'Saint Helena',
  TA: 'Tristan da Cunha',
  ER: 'Eritrea',
  AW: 'Aruba',
  FO: 'Faroe Islands',
  GL: 'Greenland',
  GI: 'Gibraltar',
  PT: 'Portugal',
  LU: 'Luxembourg',
  IE: 'Ireland',
  IS: 'Iceland',
  AL: 'Albania',
  MT: 'Malta',
  CY: 'Cyprus',
  FI: 'Finland',
  AX: 'Åland Islands',
  BG: 'Bulgaria',
  LT: 'Lithuania',
  LV: 'Latvia',
  EE: 'Estonia',
  MD: 'Moldova',
  AM: 'Armenia',
  BY: 'Belarus',
  AD: 'Andorra',
  MC: 'Monaco',
  SM: 'San Marino',
  UA: 'Ukraine',
  RS: 'Serbia',
  ME: 'Montenegro',
  XK: 'Kosovo',
  HR: 'Croatia',
  SI: 'Slovenia',
  BA: 'Bosnia and Herzegovina',
  MK: 'North Macedonia',
  CZ: 'Czech Republic',
  SK: 'Slovakia',
  LI: 'Liechtenstein',
  FK: 'Falkland Islands',
  BZ: 'Belize',
  GT: 'Guatemala',
  SV: 'El Salvador',
  HN: 'Honduras',
  NI: 'Nicaragua',
  CR: 'Costa Rica',
  PA: 'Panama',
  PM: 'Saint Pierre and Miquelon',
  HT: 'Haiti',
  GP: 'Guadeloupe',
  BL: 'Saint Barthélemy',
  MF: 'Saint Martin',
  BO: 'Bolivia',
  GY: 'Guyana',
  EC: 'Ecuador',
  GF: 'French Guiana',
  PY: 'Paraguay',
  MQ: 'Martinique',
  SR: 'Suriname',
  UY: 'Uruguay',
  CW: 'Curaçao',
  BQ: 'Caribbean Netherlands',
  TL: 'East Timor',
  NF: 'Norfolk Island',
  BN: 'Brunei',
  NR: 'Nauru',
  PG: 'Papua New Guinea',
  TO: 'Tonga',
  SB: 'Solomon Islands',
  VU: 'Vanuatu',
  FJ: 'Fiji',
  PW: 'Palau',
  WF: 'Wallis and Futuna',
  CK: 'Cook Islands',
  NU: 'Niue',
  WS: 'Samoa',
  KI: 'Kiribati',
  NC: 'New Caledonia',
  TV: 'Tuvalu',
  PF: 'French Polynesia',
  TK: 'Tokelau',
  FM: 'Federated States of Micronesia',
  MH: 'Marshall Islands',
  KP: 'North Korea',
  HK: 'Hong Kong',
  MO: 'Macau',
  KH: 'Cambodia',
  LA: 'Laos',
  BD: 'Bangladesh',
  MV: 'Maldives',
  LB: 'Lebanon',
  JO: 'Jordan',
  SY: 'Syria',
  IQ: 'Iraq',
  KW: 'Kuwait',
  SA: 'Saudi Arabia',
  YE: 'Yemen',
  OM: 'Oman',
  PS: 'Palestine',
  AE: 'United Arab Emirates',
  IL: 'Israel',
  BH: 'Bahrain',
  QA: 'Qatar',
  BT: 'Bhutan',
  MN: 'Mongolia',
  NP: 'Nepal',
  TJ: 'Tajikistan',
  TM: 'Turkmenistan',
  AZ: 'Azerbaijan',
  GE: 'Georgia',
  KG: 'Kyrgyzstan',
  UZ: 'Uzbekistan',
} as Record<string, string>;
